import React, {useState} from "react";
import {KpiProps, KpiQuery} from "../../../../../types/types";
import {QueryCard} from "./card/queryCard";
import "./sqlQueryConfigurationStep.css";
import {SqlModal} from "./modal/sqlModal";
import {ValidationErrorSection} from "../../validation/ValidationErrorSection";
import {SegmentedControl, Popover, Text, Grid} from "@mantine/core";
import {InfoCircle} from "tabler-icons-react";
import {popNotification} from "../../notification/notificationUtils";

export function SqlQueryConfigurationStep(props: KpiProps) {
    const [openModal, setOpenModal] = useState(false);
    const [opened, setOpened] = useState(false);

    function renderSqlQueryCards() {
        return props.kpiInfo.configuration.queries.map((queryInfo: KpiQuery, index: number) => {
            return (
                <Grid.Col span={1}>
                    <QueryCard
                        key={index}
                        {...queryInfo}
                        forceUpdate={forceUpdateQueries}
                        props={props}
                        plus={false}
                        isNoQuery={props.kpiInfo.configuration.queries.length === 0}
                    />
                </Grid.Col>
            );
        });
    }

    function openSqlTextEditor() {
        setOpenModal(true);
    }

    function forceUpdateQueries() {
        console.log("clearning errors")
        props.setKpiState(state => ({
            ...state,
            kpiInfo: props.kpiInfo,
            validationErrors: []
        }))
    }

    return (
        <div className="kpi-filter-wrapper full-width-height wizard-content-card ">
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <Popover
                    opened={opened}
                    onClose={() => setOpened(false)}
                    onMouseEnter={() => setOpened(true)}
                    onMouseLeave={() => setOpened(false)}
                    position="bottom"
                    placement="center"
                    withArrow
                    trapFocus={false}
                    closeOnEscape={false}
                    transition="pop-top-left"
                    width={260}
                    styles={{body: {pointerEvents: 'none'}}}
                    target={
                        <SegmentedControl onChange={value => {
                            const length = props.kpiInfo.configuration?.queries?.length || 0;
                            if (length > 0) {
                                popNotification("Alert", "You have changed the execution model. Please change your queries accordingly", "red",
                                    <InfoCircle/>);
                            }
                            props.setKpiInfo({...props.kpiInfo, executionMode: value as any})
                        }
                        } defaultValue={props.kpiInfo.executionMode} data={[
                            {value: 'BATCH', label: 'BATCH QUERY'},
                            {value: 'SPLIT', label: 'SPLIT QUERY'}
                        ]}/>
                    }
                >
                    <div style={{display: 'flex'}}>

                        <Text size="sm">Choose the Query Execution Mode. In <b>SPLIT MODE</b> the query will be
                            executed for each users. In <b>BATCH MODE</b> Query will be executed for a set of
                            users</Text>
                    </div>
                </Popover>

            </div>
            <div className="sqlQueryConfigurationStep-error">
                <ValidationErrorSection errors={props.validationErrors.filter(validationErrorObject => validationErrorObject.property === "Query")}/>
            </div>
            <Grid columns={2} className="sqlQueryConfigurationStep-container">
                {renderSqlQueryCards()}
                <Grid.Col span={1}>
                    <QueryCard
                        openSqlTextEditor={openSqlTextEditor}
                        plus={true}
                        isNoQuery={props.kpiInfo.configuration.queries.length === 0}
                    />
                </Grid.Col>
            </Grid>
            <SqlModal openModal={openModal} setOpenModal={setOpenModal} props={props} forceUpdate={forceUpdateQueries}/>
        </div>
    );
}
